<template>
	<div>
		<Loader :loading="true"/>
	</div>

</template>

<script>

import Loader from "../../components/blocks/Loader.vue";

export default {

	components: {
		Loader
	},
	data() {
		return {

		}
	},

	mounted() {
		window.top.postMessage("reload-game");
	}
}

</script>